// extracted by mini-css-extract-plugin
export default {"weekSection":"WeeklyBlock_weekSection__GJB9+","dateWeek":"WeeklyBlock_dateWeek__mZtJj","weekStats":"WeeklyBlock_weekStats__g+WSQ"};